import { createContext, useContext, type ReactNode } from 'react';
import type { SharedValue } from 'react-native-reanimated';

const HeaderFadeContext = createContext<SharedValue<number> | null>(null);

export function HeaderFadeProvider({ children, fade }: { children: ReactNode; fade: SharedValue<number> }) {
	return <HeaderFadeContext.Provider value={fade}>{children}</HeaderFadeContext.Provider>;
}

export function useHeaderFade(): SharedValue<number> | null {
	return useContext(HeaderFadeContext);
}
